import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "./axios";

const PUSHER_KEY = "8d0f2a4a46d8eb05d106";
const PUSHER_CLUSTER = "mt1";

function getAuthToken() {
  return localStorage.getItem("perfermo_provider_dashboard_user_token");
}

export function getBroadcastAuthEndpoint() {
  const base = axios.defaults.baseURL || "";

  try {
    return `${new URL(base).origin}/broadcasting/auth`;
  } catch (error) {
    return "https://backend.perfermo.com/broadcasting/auth";
  }
}

export function initEcho() {
  window.Pusher = Pusher;
  Pusher.logToConsole = true;

  const authEndpoint = getBroadcastAuthEndpoint();

  window.Echo = new Echo({
    broadcaster: "pusher",
    key: PUSHER_KEY,
    cluster: PUSHER_CLUSTER,
    forceTLS: true,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    authEndpoint,
    auth: {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAuthToken() || ""}`,
      },
    },
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        const token = getAuthToken();

        console.log("[Pusher] authorize request", {
          socketId,
          channel: channel.name,
          authEndpoint,
          hasToken: Boolean(token),
        });

        axios({
          method: "POST",
          url: authEndpoint,
          data: {
            socket_id: socketId,
            channel_name: channel.name,
          },
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        })
          .then((response) => {
            console.log("[Pusher] authorize response", {
              channel: channel.name,
              status: response.status,
              ok: true,
              data: response.data,
              rawText: JSON.stringify(response.data),
            });
            callback(null, response.data);
          })
          .catch((error) => {
            console.log("[Pusher] authorize error", {
              channel: channel.name,
              status: error.response?.status,
              message: error.response?.data || error.message,
            });
            callback(error, null);
          });
      },
    }),
  });

  const pusher = window.Echo.connector?.pusher;
  if (pusher?.connection) {
    pusher.connection.bind("state_change", (states) => {
      console.log("[Pusher] connection state", states);
    });
    pusher.connection.bind("connected", () => {
      console.log("[Pusher] connected", pusher.connection.socket_id);
    });
  }

  return window.Echo;
}
